const enum MarketplaceListingTabGroupEnums {
  Scanned = 'scanned',
  Flagged = 'flagged',
  InProgress = 'in-progress',
  CaseClosed = 'case-closed',
  Archived = 'archived',
  TestPurchase = 'test-purchase',
}
const enum MarketplaceListingInProgressTabGroupEnums {
  Requested = 'requested',
  Reported = 'reported',
  OnHold = 'on-hold',
}
const enum MarketplaceListingReportedGroupEnums {
  ReportedSubmitted = 'reported-submitted',
  SoftNotice = 'soft-notice',
}
const enum MarketplaceListingCaseClosedTabGroupEnums {
  Removed = 'removed',
  Denied = 'denied',
  NotEnforceable = 'not-enforceable',
  Dismissed = 'dismissed',
}

export type ViewMode = 'listing-grid' | 'listing-table' | 'test-purchase' | 'listing-image-cluster' | 'seller-listing';

export {
  MarketplaceListingTabGroupEnums,
  MarketplaceListingInProgressTabGroupEnums,
  MarketplaceListingReportedGroupEnums,
  MarketplaceListingCaseClosedTabGroupEnums,
};
